import { cva } from '@/styled-system/css';

// NOTE: This value must stay in sync with LEFT_NAV_WIDTH exported from constants/index.ts
// We define it here as a literal because Panda CSS cannot resolve imported constants in styles
const LEFT_NAV_WIDTH = 296;

// ZRM-16458: height of the IA TopNavBar. Must stay in sync with the height set
// on the TopNavBar component. The fixed sidebar is pushed down by this amount
// when the top bar is shown so it sits below the bar instead of under it.
const TOP_NAV_BAR_HEIGHT = 72;

export const appLayoutContainerRecipe = cva({
  base: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    '& *, & *::before, & *::after': {
      boxSizing: 'border-box',
    },
  },
  variants: {
    isLeftNav: {
      true: {
        backgroundColor: 'bg.neutral',
      },
      false: {},
    },
  },
});

export const bodyContainerRecipe = cva({
  base: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  variants: {
    isLeftNav: {
      true: {},
      false: {},
    },
    hideNavigation: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      isLeftNav: true,
      hideNavigation: false,
      css: {
        xxl: {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginLeft: `${LEFT_NAV_WIDTH}px`,
          overflowY: 'auto',
        },
      },
    },
    {
      isLeftNav: true,
      hideNavigation: true,
      css: {
        xxl: {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginLeft: 0,
          overflowY: 'auto',
        },
      },
    },
  ],
  defaultVariants: {
    isLeftNav: false,
    hideNavigation: false,
  },
});

export const layoutContainerRecipe = cva({
  base: {
    display: 'flex',
    flex: 1,
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    zIndex: 1000,
  },
  variants: {
    isLeftNav: {
      true: {
        xxl: {
          flexDirection: 'row',
        },
      },
      false: {
        xxl: {
          flexDirection: 'column',
        },
      },
    },
  },
  defaultVariants: {
    isLeftNav: false,
  },
});

export const verticalNavigationContainerRecipe = cva({
  base: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100%',
    borderRadius: '0px 0px 0px {spacing.400}',
    borderRight: '1px solid {colors.border.muted}',
    backgroundColor: 'bg.neutral',
  },
  variants: {
    hideNavigation: {
      true: {
        width: 0,
      },
      false: {
        width: `${LEFT_NAV_WIDTH}px`,
      },
    },
    // ZRM-16458: when the IA top bar is shown, drop the fixed sidebar below it
    // so the bar spans the full width above the sidebar.
    iaTopBar: {
      true: {
        top: `${TOP_NAV_BAR_HEIGHT}px`,
        height: `calc(100% - ${TOP_NAV_BAR_HEIGHT}px)`,
      },
      false: {},
    },
  },
  defaultVariants: {
    hideNavigation: false,
    iaTopBar: false,
  },
});

export const footerContainerStyles = cva({
  base: {
    backgroundColor: 'bg.neutral',
  },
  variants: {
    useLeftNav: {
      true: {
        marginLeft: { xxl: `${LEFT_NAV_WIDTH}px` },
      },
    },
  },
  defaultVariants: {
    useLeftNav: false,
  },
});
